/**
 * Dostepne typy transakcji p24
 */
export const P24TransactionType = {

    /**
     * nieznany
     */
    UNKNOWN: { id: 0, name: 'UNKNOWN', displayText: 'Nieznany' },
    /**
     * Transakcja dodana z poziomu flow24 - frontend.
     */
    FLOW24_WEB: { id: 1, name: 'FLOW24_WEB', displayText: 'Flow24 - Web' },
    /**
     * Transakcja dodana z poziomu flow lokalnego(poprzez kanal mina) z koncowki pos
     */
    FLOW_CHEQUE_TRANSACTION: { id: 2, name: 'FLOW_CHEQUE_TRANSACTION', displayText: 'Flow - Cheque' },

}

/**
 * Kolekcja typow
 */
export const P24TransactionTypeList = Object.keys(P24TransactionType).map(type => P24TransactionType[type])

/**
 * Metoda zwracająca typ transakcji bazując na identyfikatorze
 * 
 * @param {int} id identyfikator typu transakcji
 * 
 * @returns {P24TransactionType} typ transakcji
 */
export const getP24TransactionType = (id) => {
    if (!id) {
        return P24TransactionType.UNKNOWN;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let transactionType = P24TransactionTypeList.find(item => item.id === id)
    return transactionType;
}